import { type ComponentConfig } from "@puckeditor/core";
import { ProcessSteps, type ProcessStepsProps } from "./process-steps";
import { ProcessStepsFields } from "./process-steps.fields";
import { RegenerableTextField } from "../editor/RegenerableTextField";

export const ProcessStepsConfig: ComponentConfig<ProcessStepsProps> = {
  // Display label names the structure, not one use: numbered steps serve a
  // process, a timeline, or a how-it-works equally. The registry key stays
  // ProcessSteps — it's persisted in every page's Puck data.
  label: "Steps",
  fields: {
    heading: {
      ...ProcessStepsFields.heading,
      contentEditable: true,
      render: ({ value, onChange, field }) => (
        <RegenerableTextField
          value={value || ""}
          onChange={onChange}
          namespace="processSteps.heading"
          label="Heading"
          multiline={false}
          fieldMeta={field?.metadata}
        />
      ),
    },
    subheading: {
      ...ProcessStepsFields.subheading,
      contentEditable: true,
      render: ({ value, onChange, field }) => (
        <RegenerableTextField
          value={value || ""}
          onChange={onChange}
          namespace="processSteps.subheading"
          label="Subheading"
          multiline={true}
          fieldMeta={field?.metadata}
        />
      ),
    },
    layout: ProcessStepsFields.layout,
    steps: ProcessStepsFields.steps as any,
    accentColor: ProcessStepsFields.accentColor,
    backgroundColor: ProcessStepsFields.backgroundColor,
  },
  defaultProps: {
    heading: "How Our Process Works",
    subheading: "We make it simple to get the service you need with our straightforward process.",
    layout: "vertical",
    steps: [
      {
        step: 1,
        title: "Contact Us",
        description:
          "Give us a call or fill out our online form to request service. We'll respond quickly to discuss your needs.",
      },
      {
        step: 2,
        title: "Free Estimate",
        description:
          "We'll provide a detailed, upfront estimate so you know exactly what to expect. No hidden fees or surprises.",
      },
      {
        step: 3,
        title: "Schedule Service",
        description:
          "Choose a time that works for your schedule and our licensed professionals will complete the work to the highest standards.",
      },
    ],
  },
  render: ({ id, puck, editMode, ...props }) => {
    return <ProcessSteps id={id} {...props} />;
  },
};
